import React from 'react';
import PropTypes from 'prop-types';

import SearchInput from 'components/search_sidebar/sidebar_search';
import Sorting from './sorting';

export default function CompSelectorHeader({ query, sort, type, onQueryChange, onSortChange }) {
  return (
    <div className="comp-selector-header">
      <SearchInput
        placeholder="Search comps by name, address, city, or zip"
        value={query.searchTextCont || ''}
        onChange={event => onQueryChange({ searchTextCont: event.target.value })}
      />

      <div className="form-group form-inline">
        <Sorting
          sort={sort}
          type={type}
          onChange={onSortChange}
        />
      </div>
    </div>
  );
}

CompSelectorHeader.propTypes = {
  query: PropTypes.shape({
    searchTextCont: PropTypes.string,
  }).isRequired,
  sort: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
};
